export default __webpack_public_path__ + "static/6760-1d8a7d69df14c1f6c22e7b11f9082044.jpg";